import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-abnormal-activity-svg',
  imports: [],
  templateUrl: './abnormal-activity-svg.component.html',
  styleUrl: './abnormal-activity-svg.component.css'
})
export class AbnormalActivitySvgComponent {
  @Input() width: string = '50'
  @Input() height: string = '50'
  @Input() high: boolean = false
}
